import { takeEvery, put } from "redux-saga/effects";

import actions from "actions/actionTypes";
import {
  sanitizeFieldsSuccessAction,
  sanitizeFieldsFailureAction
} from "actions/sanitizeActions";
import { endOfDay, maxDateSymbol } from "utils/dates";
import { validValuesToItems } from "utils/mapping";
import { requestDisplayErrorMessageAction } from "actions/messageActions";

function* sanitizeFieldsSaga({ payload: fields }) {
  try {
    const cleanFields = fields.map(f => {
      if (f.type === "Date") {
        return {
          ...f,
          [maxDateSymbol]: endOfDay()
        };
      }

      if (typeof f.validValues !== "object") return f;
      if (f.type !== "List") return f;

      let items = validValuesToItems(f.validValues, "|");
      let validVal = items.find(x => x.value === f.value) || items[0];

      if (validVal !== f.value) {
        return {
          ...f,
          value: validVal.value
        };
      }

      return f;
    });

    yield put(sanitizeFieldsSuccessAction(cleanFields));
  } catch (error) {
    yield put(
      sanitizeFieldsFailureAction(
        new Error("Got Invalid Fields Response from API")
      )
    );
    yield put(
      requestDisplayErrorMessageAction(
        "Got Invalid Fields Response from API",
        5000
      )
    );
  }
}

export default [takeEvery(actions.SANITIZE_FIELDS, sanitizeFieldsSaga)];
